import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestGebaeudeService } from '@app/core/api/gebaeude.service';
import { ActiveGebaeudeQuery } from '@app/core/state/active-gebaeude/active-gebaeude.query';
import { ActiveGebaeudeStore } from '@app/core/state/active-gebaeude/active-gebaeude.store';
import { CompareUtil } from '@app/core/util/compare.util';
import { PayloadUtil } from '@app/core/util/payload.util';
import { Gebaeude } from '@pezi/entities';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import {setProps} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class ActiveGebaeudeService {

  private subscription: Subscription;

  constructor(private activeGebaeudeStore: ActiveGebaeudeStore,
              private activeGebaeudeQuery: ActiveGebaeudeQuery,
              private gebauedeService: RestGebaeudeService,
              private snackBar: MatSnackBar) {
  }

  initGebaeude(gebId: number, version?: number) {
    if (this.subscription) {
      this.subscription.unsubscribe();
      this.activeGebaeudeStore.data.update(setProps({
        loading: false
      }));
    }
    const currentState = this.activeGebaeudeStore.data.getValue();
    if (!gebId) {
      this.clearStore();
    } else {
      if (!currentState.gebaeude || currentState.gebaeude.id !== +gebId || !CompareUtil.hasSameVersion(version, currentState.gebaeude)) {
        const gebObservable = (!version || version === 1) ? this.gebauedeService.getGebaeude(gebId) : this.gebauedeService.getGebaeudeVersion(gebId, version);

        this.activeGebaeudeStore.data.reset();
        this.activeGebaeudeStore.data.update(setProps({
          loading: true
        }));
        this.subscription = gebObservable
          .pipe(
            take(1)
          )
          .subscribe(result => {
            let geb: Gebaeude;
            let errorLoadingGebaeude = false;
            if (PayloadUtil.handlePayloadSnackbarErrorOnly(result, this.snackBar,
              'Fehler: Gebaeude konnte nicht geladen werden')) {
              geb = result.data;
            } else {
              errorLoadingGebaeude = true;
            }
            this.activeGebaeudeStore.data.update(setProps({
              loading:      false,
              errorLoading: errorLoadingGebaeude,
              gebaeude:     geb
            }));
          });
      }
    }
  }

  clearStore() {
    this.activeGebaeudeStore.data.reset();
  }
}
